import React from 'react';
import { Spin } from 'antd';

import styles from './LoadingPage.module.css';

export default function LoadingPage() {
    return (
        <div className={styles.spinContainer}>
            <Spin tip={'Загрузка...'} size={'large'} />
        </div>
    );
}
